// extracted by mini-css-extract-plugin
module.exports = {"tabpage":"tabbar_tabpage__YtkEN"};